(() => {
  if (window.rplCartReady) return;
  window.rplCartReady = true;
  const root = () => document.querySelector('[data-rpl-cart-section]');
  if (!root()) return;
  const strings = JSON.parse(root().querySelector('[data-cart-strings]').textContent);
  const route = window.Shopify?.routes?.root || '/';
  let busy = false;
  const state = () => JSON.parse(root().querySelector('[data-cart-state]').textContent);
  const identity = item => JSON.stringify([String(item.variant_id || item.id), Object.entries(item.properties || {}).sort(([a],[b]) => a.localeCompare(b)), String(item.selling_plan_allocation?.selling_plan?.id || '')]);
  function resolveLine(previous, fresh) {
    const exact = fresh.items.find(item => item.key === previous?.key);
    if (exact) return exact;
    const matches = previous ? fresh.items.filter(item => identity(item) === identity(previous)) : [];
    return matches.length === 1 ? matches[0] : null;
  }
  function message(text, error = false) {
    const target = root()?.querySelector('[data-cart-status]');
    if (!target) return;
    target.textContent = text; target.dataset.error = String(error);
  }
  async function request(path, body) {
    const response = await fetch(route + path, { method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, ...(body ? { body: JSON.stringify(body) } : {}) });
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(data.description || strings.error);
    return data;
  }
  function codes(cart) {
    const list = [...(cart.discount_codes || []).filter(code => code.applicable !== false).map(code => code.code), ...(cart.cart_level_discount_applications || []).filter(d => d.type === 'discount_code').map(d => d.title), ...cart.items.flatMap(item => (item.line_level_discount_allocations || []).filter(d => d.discount_application?.type === 'discount_code').map(d => d.discount_application.title))];
    return [...new Set(list.map(code => code.toUpperCase()))];
  }
  async function render(cart, sectionId) {
    let html = cart.sections?.[sectionId];
    if (!html) {
      const url = new URL(location.href); url.searchParams.set('section_id', sectionId);
      const response = await fetch(url, { cache: 'no-store' }); if (!response.ok) throw new Error(strings.error); html = await response.text();
    }
    const replacement = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-rpl-cart-section]');
    if (!replacement) throw new Error(strings.error);
    const note = root().querySelector('[name="note"]')?.value;
    root().replaceWith(replacement);
    const nextNote = replacement.querySelector('[name="note"]'); if (nextNote && note !== undefined) nextNote.value = note;
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'rpl:cart-update', cart } }));
    document.dispatchEvent(new CustomEvent('rpl:cart-render'));
  }
  async function update(action) {
    if (busy) return;
    busy = true;
    const sectionId = root().dataset.rplCartSection;
    root().setAttribute('aria-busy','true'); message(strings.busy);
    const disabled = [...root().querySelectorAll('button,input,select')].filter(el => !el.disabled);
    disabled.forEach(el => el.disabled = true);
    try {
      const fresh = await request('cart.js');
      const operation = action(fresh);
      const sections = [sectionId];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
      const cart = await request(operation?.path || 'cart/update.js', { ...(operation?.body || {}), sections: [...new Set(sections)].slice(0,5), sections_url: location.pathname + location.search });
      await render(cart, sectionId);
      let text = operation ? strings.updated : strings.changed;
      let error = !operation;
      if (operation?.code && !codes(cart).includes(operation.code.toUpperCase())) { text = strings.invalid; error = true; }
      message(text,error);
      root().querySelector('[data-cart-status]')?.focus({preventScroll:true});
    } catch (error) { message(error.message || strings.error, true); }
    finally { busy = false; root()?.removeAttribute('aria-busy'); disabled.forEach(el => { if (el.isConnected) el.disabled = false; }); }
  }
  function discount(remove) {
    const input = root().querySelector('[data-cart-code]');
    const code = remove || input.value.trim();
    if (!code) { message(strings.empty_code,true); input.focus(); return; }
    update(cart => ({ path: 'cart/update.js', body: { discount: (remove ? codes(cart).filter(c => c !== code.toUpperCase()) : [...new Set([...codes(cart),code.toUpperCase()])]).join(',') }, ...(remove ? {} : {code}) }));
  }
  function quantity(key, amount) {
    if (!Number.isInteger(amount) || amount < 0) { message(strings.error,true); return; }
    const previous = state().items.find(item => item.key === key);
    update(cart => { const item = resolveLine(previous,cart); return item ? { path: 'cart/change.js', body: { id: item.key, quantity: amount } } : null; });
  }
  document.addEventListener('click', event => {
    const target = event.target.closest('a,button'); if (!target || !root()?.contains(target)) return;
    if (target.matches('[data-cart-apply],[data-cart-remove-code]')) { event.preventDefault(); event.stopImmediatePropagation(); if (!busy) discount(target.dataset.cartRemoveCode); return; }
    if (target.matches('a[href*="/cart/change"]')) {
      event.preventDefault(); event.stopImmediatePropagation(); if (busy) return;
      const url = new URL(target.href); quantity(url.searchParams.get('id'), Number(url.searchParams.get('quantity')));
    }
  },true);
  document.addEventListener('change', event => {
    if (!root()?.contains(event.target) || !event.target.matches('input[data-line-key]')) return;
    event.preventDefault(); event.stopImmediatePropagation(); if (!busy) quantity(event.target.dataset.lineKey, Number(event.target.value));
  },true);
  document.addEventListener('keydown', event => {
    if (event.key === 'Enter' && event.target.matches('[data-cart-code]')) { event.preventDefault(); if (!busy) discount(); }
  },true);
  document.addEventListener('submit', event => { if (busy && root()?.contains(event.target)) {event.preventDefault(); event.stopImmediatePropagation();} },true);
  document.addEventListener('cart:prepare-bundled-sections', event => {
    const sectionId=root()?.dataset.rplCartSection;if(sectionId&&!event.detail.sections.includes(sectionId))event.detail.sections.push(sectionId);
  });
  document.addEventListener('cart:change', event => {
    if(event.detail?.baseEvent==='rpl:cart-update'||!root()||busy)return;
    render(event.detail.cart,root().dataset.rplCartSection).catch(error=>message(error.message,true));
  });
  document.addEventListener('rpl:cart-refresh', () => update(() => ({path:'cart/update.js',body:{}})));
})();
